import React from 'react';
import {
  Main,
  FirstChild,
  SecondChild,
  ThirdChild,
  FourthChild,
} from './components';

type LoadingSpinnerProps = {
  size: number;
  marginLeft?: number;
  'aria-hidden'?: boolean;
  'aria-label'?: string;
};

const LoadingSpinner = ({ 
  size, 
  marginLeft = 0, 
  'aria-hidden': ariaHidden = false,
  'aria-label': ariaLabel = 'Loading...'
}: LoadingSpinnerProps) => {
  return (
    <Main 
      size={size} 
      marginLeft={marginLeft}
      role="status"
      aria-hidden={ariaHidden}
      aria-label={ariaHidden ? undefined : ariaLabel}
    >
      <FirstChild size={size}></FirstChild>
      <SecondChild size={size}></SecondChild>
      <ThirdChild size={size}></ThirdChild>
      <FourthChild size={size}></FourthChild>
      {!ariaHidden && (
        <span className="visually-hidden">{ariaLabel}</span>
      )}
    </Main>
  );
};

export default LoadingSpinner;
